/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
var ENTER_KEY = 'Enter';
var CLICK = 'click';
var KEYPRESS = 'keypress';
var hideOnPopperBlur = {
  name: 'hideOnPopperBlur',
  defaultValue: true,
  fn: function fn(instance) {
    return {
      onCreate: function onCreate() {
        instance.popper.addEventListener('focusout', function (event) {
          if (instance.props.hideOnPopperBlur && event.relatedTarget && !instance.popper.contains(event.relatedTarget) && !event.target.classList.contains('share-link')) {
            instance.hide();
          }
        });
      }
    };
  }
};
var ShareMenu = function () {
  function ShareMenu() {
    _classCallCheck(this, ShareMenu);
    this.optionsIcon = document.querySelector('.options-menu');
    this.isInitial = true;
  }
  return _createClass(ShareMenu, [{
    key: "setShareButtonClickHandlers",
    value: function setShareButtonClickHandlers() {
      var _this = this;
      var shareIcons = null;
      var printIcons = null;
      var emailIcons = null;
      if (this.isInitial) {
        shareIcons = document.querySelectorAll('.share-link');
        printIcons = document.querySelectorAll('.print-link');
        emailIcons = document.querySelectorAll('.email-link');
        this.isInitial = false;
      } else {
        shareIcons = document.querySelectorAll('.tippy-content .share-link');
        printIcons = document.querySelectorAll('.tippy-content .print-link');
        emailIcons = document.querySelectorAll('.tippy-content .email-link');
      }
      if (shareIcons) {
        shareIcons.forEach(function (item) {
          item.addEventListener(CLICK, _this.shareCallback);
          item.addEventListener(KEYPRESS, _this.shareCallback);
        });
      }
      if (printIcons) {
        printIcons.forEach(function (item) {
          item.addEventListener(CLICK, ShareMenu.printCallback);
          item.addEventListener(KEYPRESS, ShareMenu.printCallback);
        });
      }
      if (emailIcons) {
        emailIcons.forEach(function (item) {
          item.addEventListener(CLICK, ShareMenu.emailCallback);
          item.addEventListener(KEYPRESS, ShareMenu.emailCallback);
        });
      }
    }
  }, {
    key: "shareCallback",
    value: function shareCallback(event) {
      if (event.type === CLICK || event.key === ENTER_KEY) {
        var dummy = document.createElement('input');
        var text = window.location.href;
        var tippyTextListItem = document.querySelector('.share-tippytext');
        var tippyText = tippyTextListItem !== null ? tippyTextListItem.title : 'URL copied to clipboard!';
        document.body.appendChild(dummy);
        dummy.value = text;
        dummy.select();
        document.execCommand('copy');
        document.body.removeChild(dummy);
        var instance = tippy(this, {
          content: tippyText
        });
        instance.show();
        setTimeout(function () {
          instance.destroy();
        }, 1000);
      }
    }
  }, {
    key: "setMobileClickHandlers",
    value: function setMobileClickHandlers() {
      if (this.optionsIcon) {
        var that = this;
        tippy(this.optionsIcon, {
          content: function content() {
            var mobileMenu = document.querySelector('.menu--share-menu .mobile-view .menu-items');
            return mobileMenu.innerHTML;
          },
          allowHTML: true,
          placement: 'bottom-end',
          duration: [250, 200],
          theme: 'light',
          interactive: true,
          trigger: 'mouseenter focus click',
          plugins: [hideOnPopperBlur],
          onShown: function onShown() {
            that.setShareButtonClickHandlers();
          }
        });
      }
    }
  }], [{
    key: "emailCallback",
    value: function emailCallback(event) {
      if (event.type === CLICK || event.key === ENTER_KEY) {
        var windowLocation = window.location.href;
        window.open("mailto:?body=\"".concat(windowLocation, "\""));
      }
    }
  }, {
    key: "printCallback",
    value: function printCallback(event) {
      if (event.type === CLICK || event.key === ENTER_KEY) {
        window.print();
      }
    }
  }]);
}();
export { ShareMenu as default };
(function () {
  var shareMenu = new ShareMenu();
  shareMenu.setShareButtonClickHandlers();
  shareMenu.setMobileClickHandlers();
})(Drupal);